import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class ExportOrdersService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public GetWeekOfYear(year: number): any {
        return this.baseApiFactory.getData<any[]>('/api/Order/GetWeekOfYear?year=' + year);
    }

    public ExportOrderDaily(date: string, countryCode: string, dealerNumber: string): void {
        this.baseApiFactory.download('/api/Order/ExportOrderDaily?date=' + date + "&countryCode=" + countryCode + "&dealerNumber=" + dealerNumber, {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            fileName: "ExportOrderDaily_" + date + "_" + countryCode + "_" + dealerNumber + ".xlsx"
        });
    }

    public ExportOrderWeekly(year: number, week: number, countryCode: string, dealerNumber: string): void {
        this.baseApiFactory.download('/api/Order/ExportOrderWeekly?year=' + year + '&week=' + week + "&countryCode=" + countryCode + "&dealerNumber=" + dealerNumber, {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            fileName: "ExportOrderWeekly_" + year + "_" + week + "_" + countryCode + "_" + dealerNumber + ".xlsx"
        });
    }

    public ExportOrderMonthly(year: number, month: number, countryCode: string, dealerNumber: string): void {
        this.baseApiFactory.download('/api/Order/ExportOrderMonthly?year=' + year + '&month=' + month + "&countryCode=" + countryCode + "&dealerNumber=" + dealerNumber, {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            fileName: "ExportOrderMonthly_" + year + "_" + month + "_" + countryCode + "_" + dealerNumber + ".xlsx"
        });
    }

    public ExportOrderYearly(year: number, countryCode: string, dealerNumber: string): void {
        this.baseApiFactory.download('/api/Order/ExportOrderYearly?year=' + year + "&countryCode=" + countryCode + "&dealerNumber=" + dealerNumber, {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            fileName: "ExportOrderYearly_" + year + "_" + countryCode + "_" + dealerNumber + ".xlsx"
        });
    }
}


lazyRegister.service('ExportOrdersService', ExportOrdersService);
